<template>
  <DropdownTooltip
    v-tooltip.bottom="{ content: 'Timesheets', theme: 'info-tooltip' }"
    distance="8"
    placement="bottom"
    iconSize="none"
    class="timesheet-menu header__icon-link"
    popperClass="timesheet-menu__popper"
    aria-label="Timesheets"
  >
    <template #tooltip-label>
      <icon
        class="img-icon-fill"
        data="@icon/clock.svg"
        :fill="true"
        width="var(--icon-24)"
        height="var(--icon-24)"
        color="#81889B"
      />
    </template>
    <template #tooltip-content="{ hide }">
      <div class="timesheet-menu__list">
        <template v-for="(item, index) in menu">
          <router-link
            v-if="item.visible"
            :key="index"
            class="timesheet-menu__item"
            :to="item.to"
            @click="hide()"
          >
            <icon
              :data="item.icon"
              class="timesheet-menu__icon"
              width="var(--icon-24)"
              height="var(--icon-24)"
            />
            <BaseSubHeading
              weight="400"
              size="medium"
              class="timesheet-menu__name"
            >
              {{ item.label }}
            </BaseSubHeading>
          </router-link>
        </template>
      </div>
    </template>
  </DropdownTooltip>
</template>

<script lang="ts" setup>
import { useAcl } from "vue-simple-acl"
import historyDark from "@icon/history-timesheet-dark.svg"
import history from "@icon/history-timesheet.svg"
import reviewDark from "@icon/review-dark.svg"
import review from "@icon/review.svg"
import summariesDark from "@icon/summaries-dark.svg"
import summaries from "@icon/summaries.svg"
import { computed } from "vue"

import DropdownTooltip from "@/components/Dropdown/DropdownTooltip.vue"

const timesheetApprovalEnabled = computed(() => {
  return useAcl().can.any("canReviewTimesheet")
})

const menu = computed(() => [
  {
    id: "history",
    icon: history,
    iconDark: historyDark,
    label: "My Timesheets",
    fill: true,
    visible: true,
    to: {
      name: "myTimesheet"
    }
  },
  {
    id: "review",
    icon: review,
    iconDark: reviewDark,
    label: "Timesheet Approval",
    to: {
      name: "timesheetApproval"
    },
    fill: true,
    visible: timesheetApprovalEnabled.value
  },
  {
    id: "summaries",
    icon: summaries,
    iconDark: summariesDark,
    label: "Monthly Summary",
    fill: false,
    visible: timesheetApprovalEnabled.value,
    to: {
      name: "timesheetSummaries"
    }
  }
])
</script>

<style lang="scss">
.timesheet-menu {
  &__popper {
    width: 228px;

    .v-popper__inner {
      border-radius: var(--radius-section);
    }
  }
}
</style>

<style lang="scss" scoped>
@import "@/assets/scss/utils/mixins/_flex";

.timesheet-menu {
  @include flex;

  &__item {
    @include flex;

    padding: var(--step2);
    gap: var(--step2);

    .timesheet-menu__name,
    .timesheet-menu__icon {
      color: var(--monochrome-05);
    }

    &:hover {
      border-radius: 2px;
      background: var(--monochrome-01);

      .timesheet-menu__name,
      .timesheet-menu__icon {
        color: var(--monochrome-06);
      }
    }
  }
}

.dark {
  .timesheet-menu {
    &__item {
      .timesheet-menu__name,
      .timesheet-menu__icon {
        color: var(--monochrome-04);
      }

      &:hover {
        background: var(--monochrome-16);
        color: var(--monochrome-07);

        .timesheet-menu__name,
        .timesheet-menu__icon {
          color: var(--monochrome-07);
        }
      }
    }
  }
}
</style>
